<button
  class="text-white font-bold rounded-l-full rounded-r-full block w-full max-w-md h-16 lg:h-12 lg:w-36"
  langRouterLink="getdemo"
>
  {{ "buttons.contact_us" | translate }}
</button>
